export default __webpack_public_path__ + "static/media/profileDefault.bb24c46c.svg";